module.exports = __webpack_public_path__ + "img/emoPeoples.380b08fb.svg";